/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { personShow } from '../../axios/personShow'
import type { PersonShowError, PersonShowPathParams, PersonShowResponse } from '../../types/PersonShow'

export const personShowQueryKey = (
	organisationId: PersonShowPathParams['organisationId'],
	person: PersonShowPathParams['person'],
) => [{ url: '/organisations/:organisationId/persons/:person', params: { organisationId, person } }] as const

export type PersonShowQueryKey = ReturnType<typeof personShowQueryKey>

/** @see backend/nexus/modules/Campaign/Http/Controllers/PersonController.php PersonController::show */
export function personShowQueryOptions(
	organisationId: PersonShowPathParams['organisationId'],
	person: PersonShowPathParams['person'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<PersonShowResponse, AxiosError<PersonShowError>, PersonShowResponse, PersonShowQueryKey>({
		queryKey: personShowQueryKey(organisationId, person),
		queryFn: ({ signal }) => personShow(organisationId, person, { signal, ...config }).then(res => res.data),
		enabled: !!(organisationId && person),
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/PersonController.php PersonController::show */
export function usePersonShow<TSelectData = PersonShowResponse>(
	organisationId: PersonShowPathParams['organisationId'],
	person: PersonShowPathParams['person'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<PersonShowResponse, AxiosError<PersonShowError>, TSelectData, PersonShowQueryKey>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<PersonShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...personShowQueryOptions(organisationId, person),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/PersonController.php PersonController::show */
export function usePersonShowSuspense<TSelectData = PersonShowResponse>(
	organisationId: PersonShowPathParams['organisationId'],
	person: PersonShowPathParams['person'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					PersonShowResponse,
					AxiosError<PersonShowError>,
					TSelectData,
					PersonShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<PersonShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...personShowQueryOptions(organisationId, person),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
